// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__KzXe8","resendInfoText":"OnGoingPaymentBox_resendInfoText__uuUdz"};